var map = {
	"./monthly_customer_registration_count.svg": "29b6",
	"./monthly_earn_transaction_count.svg": "7637",
	"./monthly_redeem_transaction_count.svg": "5b24",
	"./monthly_sms_count.svg": "cbf5",
	"./yearly_customer_registration_count.svg": "c162",
	"./yearly_earn_transaction_count.svg": "a1da",
	"./yearly_redeem_transaction_count.svg": "b344"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "68d2";